import { combineReducers } from "redux";
import settings from "./siteSettings";

export default combineReducers({
  settings,
});
